import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialProjectState: Dtos.Project & IRegistrationFormState = {
    id: null,
    projectProtocolID: null,
    projectScientificTitle: null,
    projectShortTitle: null,
    projectAckSource: null,
    projectTrialDeveloperId: null,
    projectDateSubmitted: null,
    projectOutcomeId: null,
    display: null,
    protocolID: null,
    studyAcronym: null,
    shortTitle: null,
    title: null,
    displayName: null,
    shortDisplay: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    projectInvestigators: []
}

export interface IProjectReduxFormState {
    id: IFieldState<number>,
    projectProtocolID: IFieldState<string>,
    projectScientificTitle: IFieldState<string>,
    projectShortTitle: IFieldState<string>,
    projectAckSource: IFieldState<string>,
    projectTrialDeveloperId: IFieldState<number>,
    projectDateSubmitted: IFieldState<string>,
    projectOutcomeId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
